export default "__VITE_ASSET__BIDy6xXi__"